import { render, staticRenderFns } from "./PostDetailView.vue?vue&type=template&id=a8c2fba2"
import script from "./PostDetailView.vue?vue&type=script&lang=js"
export * from "./PostDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports